import { useContext, useState, useEffect } from 'react';
import { Modal, Box, Button, Grid } from '@mui/material';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import Avatar from '@mui/material/Avatar';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import BusinessIcon from '@mui/icons-material/Business';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import useMediaQuery from '@mui/material/useMediaQuery';
// Our Components
import { AuthContext } from 'context/auth-context';
import { KYXContext } from 'context/kyx-context';
import { KYXEulaFirstStep } from '../KYXEula/KYXEulaFirstStep';
import { KYXEulaSecondStep } from '../KYXEula/KYXEulaSecondStep';
import { KYXEulaThirdStep } from '../KYXEula/KYXEulaThirdStep';
// Services
import { Users } from 'lib/api';
// Utils and Helpers
import { EULAS } from 'helpers/constants';
// Assets
import group842 from 'assets/modalKYX/group-842.png';
import hand from 'assets/modalKYX/hand.png';
import './PreKycWelcome.css';

export const ModalPreKycWelcome = ({ open, handlePreKyc }) => {
    const { userInfo } = useContext(AuthContext);
    const { setCurrentKYCStep, setIsKYXModalOpen } = useContext(KYXContext);
    const [numModal, setNumModal] = useState(0);
    const handleChange = num => {
        setNumModal(num);
    };

    const extraSmall = useMediaQuery('(max-width:900px)');

    const handleKYClose = (e, reason) => {
        if (reason === 'backdropClick') {
            return false;
        }
        setCurrentKYCStep(0);
        setIsKYXModalOpen(true);
        handlePreKyc(e, reason);
    };

    setIsKYXModalOpen(false);

    useEffect(() => {
        const fetchLastEula = async () => {
            try {
                const lastEula = await Users.getLastEULA(userInfo.id);
                if (lastEula.lastAcceptedEula === EULAS.E_SIGNATURE_AGREEMENT) {
                    setNumModal(6);
                } else if (lastEula.lastAcceptedEula === EULAS.END_USER_LEGAL_AGREEMENTS) {
                    setNumModal(7);
                }
            } catch (error) {
                console.error(error);
            }
        };
        fetchLastEula();
    }, [userInfo.id]);

    return (
        <Modal open={open} onClose={handleKYClose} aria-describedby="child-modal-pre-kyc">
            <Box
                className="preKYC-modal"
                sx={{
                    border: { xs: '8px solid gray', md: 'unset' },
                    width: { xs: '404px', md: '800px' },
                    height: { xs: '726px', md: '600px' }
                }}>
                {numModal === 0 ? (
                    <Grid container direction={'row-reverse'}>
                        <Grid
                            item
                            width={{ xs: '388px', md: 'auto' }}
                            height={{ xs: '256px !important', md: '568px !important' }}
                            xs={12}
                            md={5}>
                            <Box
                                className="box-blue"
                                sx={{
                                    backgroundSize: { xs: '85% 95%', md: '100% 70%' },
                                    width: { xs: '388px', md: 'auto' },
                                    height: { xs: '256px !important', md: '568px !important' }
                                }}></Box>
                        </Grid>

                        <Grid
                            item
                            width={{ xs: '388px', md: '348px' }}
                            height={{ xs: '454px !important', md: '309px !important' }}
                            xs={12}
                            md={7}>
                            <Box
                                className="box-data"
                                sx={{
                                    margin: { xs: '48px 33px 10px 33px', md: '88px 0px 100px 56px' },
                                    width: { xs: '348px', md: 'auto' },
                                    height: { xs: '309px !important', md: '309px !important' }
                                }}>
                                <img className="img-hand" src={hand} alt="pre-kyc" />
                                <label className="name-user">Hello, {userInfo.first_name}</label>
                                <label className="txt-big-blue">Welcome to Paystand's DeFi Corporate Card! </label>
                                <label className="complement-info">
                                    We're excited to have you on board. Start <br />
                                    simplifying your expense management today.
                                </label>
                            </Box>
                            <Button
                                onClick={() => {
                                    handleChange(1);
                                }}
                                className="continue-button"
                                sx={{ margin: { xs: '0px 0px 0px 250px ', md: '0px 0px 0px 290px' } }}>
                                Continue
                            </Button>
                        </Grid>
                    </Grid>
                ) : numModal === 1 ? (
                    <Grid container direction={'row-reverse'}>
                        <Grid
                            item
                            width={{ xs: '388px', md: 'auto' }}
                            height={{ xs: '256px !important', md: '568px !important' }}
                            xs={12}
                            md={5}>
                            <Box
                                className="box-blue-3"
                                sx={{
                                    backgroundSize: { xs: '90% 90%', md: '90% 45%' },
                                    backgroundPositionX: { xs: '34px, -40px', md: '80px, -20px' },
                                    backgroundPositionY: { xs: '92px, 10px', md: '200px, 70px' },
                                    width: { xs: '388px', md: 'auto' },
                                    height: { xs: '256px !important', md: '568px !important' }
                                }}></Box>
                        </Grid>
                        <Grid
                            md={7}
                            width={{ xs: 'auto', md: 'auto' }}
                            height={{ xs: '454px !important', md: '287px !important' }}
                            xs={12}>
                            <Box
                                className="box-data-3"
                                sx={{
                                    margin: { xs: '20px 33px 130px 33px', md: '88px 0px 185px 56px' },
                                    width: { xs: '348px', md: '348px' },
                                    height: { xs: '222px !important', md: '222px !important' }
                                }}>
                                <Box className="Counter">
                                    <Box className="numbers">
                                        <span className="actual">1</span>
                                        <span className="total">/3</span>
                                    </Box>
                                </Box>
                                <label className="txt-big-blue">Control your expenses with unique virtual & physical cards</label>

                                <label className="complement-info">
                                    Give each employee a corporate card with custom spend controls or set up cards to pay specific
                                    vendors. Set custom spend limits and categorise cards up front.
                                </label>
                            </Box>
                            <Box className="arrow-buttons">
                                <button
                                    className="back"
                                    onClick={() => {
                                        handleChange(0);
                                    }}>
                                    <ChevronLeftIcon className="chevron-left"></ChevronLeftIcon>
                                </button>

                                <button
                                    className="next"
                                    onClick={() => {
                                        handleChange(2);
                                    }}>
                                    <ChevronRightIcon className="chevron-right"></ChevronRightIcon>
                                </button>
                            </Box>
                        </Grid>
                    </Grid>
                ) : numModal === 2 ? (
                    <Grid container direction={'row-reverse'}>
                        <Grid
                            item
                            width={{ xs: '388px', md: 'auto' }}
                            height={{ xs: '256px !important', md: '568px !important' }}
                            xs={12}
                            md={5}>
                            <Box
                                className="box-blue-2"
                                sx={{
                                    backgroundSize: { xs: '65% 90%', md: '90% 45%' },
                                    width: { xs: '388px', md: 'auto' },
                                    height: { xs: '256px !important', md: '568px !important' }
                                }}></Box>
                        </Grid>

                        <Grid
                            item
                            md={7}
                            width={{ xs: 'auto', md: 'auto' }}
                            height={{ xs: '454px !important', md: '222px !important' }}
                            xs={12}>
                            <Box
                                className="box-data-2"
                                sx={{
                                    margin: { xs: '48px 33px 102px 33px', md: '88px 0px 185px 56px' },
                                    width: { xs: '348px', md: '348px' },
                                    height: { xs: '222px !important', md: '222px !important' }
                                }}>
                                <Box className="Counter">
                                    <Box className="numbers">
                                        <span className="actual">2</span>
                                        <span className="total">/3</span>
                                    </Box>
                                </Box>
                                <label className="txt-big-blue">Earn bitcoin rewards</label>

                                <label className="complement-info">
                                    Earn 1% back in Bitcoin on every card purchase - a reward that may appreciate in value and
                                    accrues in real time!{' '}
                                </label>
                            </Box>
                            <Box className="arrow-buttons">
                                <button
                                    className="back"
                                    onClick={() => {
                                        handleChange(1);
                                    }}>
                                    <ChevronLeftIcon className="chevron-left"></ChevronLeftIcon>
                                </button>

                                <button
                                    className="next"
                                    onClick={() => {
                                        handleChange(3);
                                    }}>
                                    <ChevronRightIcon className="chevron-right"></ChevronRightIcon>
                                </button>
                            </Box>
                        </Grid>
                    </Grid>
                ) : numModal === 3 ? (
                    <Grid container direction={'row-reverse'}>
                        <Grid
                            iitem
                            width={{ xs: '388px', md: 'auto' }}
                            height={{ xs: '256px !important', md: '568px !important' }}
                            xs={12}
                            md={5}>
                            {extraSmall ? (
                                <Box
                                    className="box-blue-4xs"
                                    sx={{
                                        backgroundSize: { xs: '40% 45%,10% 4%,70% 70%', md: '90% 55%, 4% 10%, 80% 45%' },
                                        backgroundPositionX: { xs: '30px,center,150px', md: 'center' },
                                        backgroundPositionY: { xs: 'center', md: 'top, center, bottom' },
                                        width: { xs: '388px', md: 'auto' },
                                        height: { xs: '256px !important', md: '568px !important' }
                                    }}></Box>
                            ) : (
                                <Box
                                    className="box-blue-4"
                                    sx={{
                                        backgroundSize: { xs: '40% 45%,10% 4%,70% 70%', md: '90% 55%, 4% 10%, 80% 45%' },
                                        backgroundPositionX: { xs: '30px,center,150px', md: 'center' },
                                        backgroundPositionY: { xs: 'center', md: 'top, center, bottom' },
                                        width: { xs: '388px', md: 'auto' },
                                        height: { xs: '256px !important', md: '568px !important' }
                                    }}></Box>
                            )}
                        </Grid>

                        <Grid
                            md={7}
                            width={{ xs: 'auto', md: 'auto' }}
                            height={{ xs: '454px !important', md: '353px !important' }}
                            xs={12}>
                            <Box
                                className="box-data-4"
                                sx={{
                                    margin: { xs: '20px 33px -1px 33px', md: '88px 0px 54px 56px' },
                                    width: { xs: '348px', md: '348px' },
                                    height: { xs: '353px !important ', md: '353px !important' }
                                }}>
                                <Box className="Counter">
                                    <Box className="numbers">
                                        <span className="actual">3</span>
                                        <span className="total">/3</span>
                                    </Box>
                                </Box>
                                <label className="txt-big-blue">Your account operates on a daily payment cycle</label>

                                <label className="complement-info">
                                    With Paystand, you receive an account spend limit. Every 24 hours, Paystand initiates an ACH
                                    pull on your business's bank account to pay back what you spent. The payment typically settles
                                    within 4-6 business days, at which point your account's available balance will be restored.
                                </label>
                            </Box>
                            <Box className="arrow-buttons">
                                <button
                                    className="back"
                                    onClick={() => {
                                        handleChange(2);
                                    }}>
                                    <ChevronLeftIcon className="chevron-left"></ChevronLeftIcon>
                                </button>

                                <button
                                    className="next"
                                    onClick={() => {
                                        handleChange(4);
                                    }}>
                                    <ChevronRightIcon className="chevron-right"></ChevronRightIcon>
                                </button>
                            </Box>
                        </Grid>
                    </Grid>
                ) : numModal === 4 ? (
                    <Grid container direction={'row-reverse'}>
                        <Grid
                            iitem
                            width={{ xs: '388px', md: 'auto' }}
                            height={{ xs: '256px !important', md: '568px !important' }}
                            xs={12}
                            md={5}>
                            <Box
                                className="box-blue-5"
                                sx={{
                                    width: { xs: '388px', md: '340px' },
                                    height: { xs: '256px !important', md: '568px !important' }
                                }}></Box>
                            <Box
                                className="box-blue-6"
                                sx={{
                                    width: { xs: '331px', md: '190px' },
                                    height: { xs: '194px', md: '416px' }
                                }}>
                                <Box className="blue-frame-1">
                                    <Box className="box-badge-icon">
                                        <Avatar
                                            sx={{
                                                bgcolor: { xs: 'white', md: 'white' },
                                                zIndex: { xs: '1', md: '1' },
                                                width: { xs: '40px', md: '64px' },
                                                height: { xs: '40px', md: '64px' },
                                                border: { xs: 'solid 1px #D0D5D9', md: 'solid 1px #D0D5D9' }
                                            }}>
                                            <BadgeOutlinedIcon className="badge-icon" />
                                        </Avatar>
                                    </Box>
                                    <label className="last-text">1. Verify Yourself</label>
                                </Box>
                                <div className="vertical"></div>
                                <Box className="blue-frame-2">
                                    <Box className="box-badge-icon">
                                        <Avatar
                                            sx={{
                                                bgcolor: { xs: 'white', md: 'white' },
                                                zIndex: { xs: '1', md: '1' },
                                                width: { xs: '40px', md: '64px' },
                                                height: { xs: '40px', md: '64px' },
                                                border: { xs: 'solid 1px #D0D5D9', md: 'solid 1px #D0D5D9' }
                                            }}>
                                            <BusinessIcon className="badge-icon" />
                                        </Avatar>
                                    </Box>
                                    <label className="last-text">2. Verify Your Business</label>
                                </Box>
                                <div className="vertical"></div>
                                <Box className="blue-frame-3">
                                    <Box className="box-badge-icon">
                                        <Avatar
                                            sx={{
                                                bgcolor: { xs: 'white', md: 'white' },
                                                zIndex: { xs: '1', md: '1' },
                                                width: { xs: '40px', md: '64px' },
                                                height: { xs: '40px', md: '64px' },
                                                border: { xs: 'solid 1px #D0D5D9', md: 'solid 1px #D0D5D9' }
                                            }}>
                                            <AccountBalanceIcon className="badge-icon" />
                                        </Avatar>
                                    </Box>
                                    <label className="last-text">3. Link your bank</label>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid
                            md={7}
                            width={{ xs: 'auto', md: 'auto' }}
                            height={{ xs: '454px !important', md: '287px !important' }}
                            xs={12}>
                            <Box
                                className="box-data-5"
                                sx={{
                                    margin: { xs: '9px 33px 160px 33px', md: '88px 0px 120px 56px' },
                                    width: { xs: '348px', md: '348px' },
                                    height: { xs: '227px !important ', md: '265px !important' }
                                }}>
                                <img className="img-hand" src={group842} alt="Payment-Approved" />
                                <label className="txt-big-blue">Let's get started!</label>
                                <label className="complement-info">Here's what you will need to complete your application:</label>
                                <label className="txt-small-blue">
                                    <ul>
                                        <li>Social Security Number</li>
                                        <li>Residential Address</li>
                                        <li>Employer Identification Number (EIN)</li>
                                        <li>Business Address</li>
                                        <li>Business Owner Information</li>
                                        <li>Business Checking or Savings Account Credentials</li>
                                    </ul>
                                </label>
                            </Box>
                            <Box
                                className="arrow-buttons-last"
                                sx={{
                                    marginLeft: { xs: '120px', md: '170px' },
                                    marginTop: { xs: '90px', md: '150px' }
                                }}>
                                <button
                                    className="back"
                                    onClick={() => {
                                        handleChange(3);
                                    }}>
                                    <ChevronLeftIcon className="chevron-left"></ChevronLeftIcon>
                                </button>

                                <button
                                    className="button-last"
                                    onClick={() => {
                                        handleChange(5);
                                    }}>
                                    <label className="start-verification-txt">Start Verification</label>
                                </button>
                            </Box>
                        </Grid>
                    </Grid>
                ) : numModal === 5 ? (
                    <KYXEulaFirstStep handleChange={handleChange} />
                ) : numModal === 6 ? (
                    <KYXEulaSecondStep handleChange={handleChange} />
                ) : (
                    <KYXEulaThirdStep handleKYClose={handleKYClose} />
                )}
            </Box>
        </Modal>
    );
};
